import { Controller } from "stimulus";
import { getCSRFToken } from "../util";
import { getCookie } from "../util";

import Flatpickr from "flatpickr";

import {chartTranslations, HIGHCHARTS_COLORS} from "../config";

let now = new Date();
const default_start_date = new Date(now. setDate(now.getDate() - 30));

let dateRangeInput;

export default class extends Controller {
  static targets = ["chart", "spinner", "selectedDateRange", "selectedApiKey", "selectedInterval"];
  static values = { url: String };

  connect() {
    // Load Flatpickr
    this._showSpinner();
    var link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("type", "text/css");
    link.setAttribute("href", "https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css");
    document.getElementsByTagName("head")[0].appendChild(link);


    this.initSelectDatePicker();

    this.selectedApiKey = 0;
    this.selectedInterval = "daily";
    this.selectedStartDate = dateRangeInput.selectedDates[0].getTime();
    this.selectedEndDate = dateRangeInput.selectedDates[1].getTime();
    this.enableDataGrouping = false;
    this.chart = null;
    this._renderChart();
  }

  _showSpinner(show = true) {
    this.spinnerTarget.style.display = show ? "" : "none";
  }

  initSelectDatePicker() {
    dateRangeInput = Flatpickr(this.selectedDateRangeTarget, {
                        static: true,
                        clickOpens: false,
                        mode: "range",
                        dateFormat: "d-M-y",
                        defaultDate: [default_start_date, Date.now()],
                        onClose: () => {
                          this.selectedStartDate = dateRangeInput.selectedDates[0].getTime();
                          this.selectedEndDate = dateRangeInput.selectedDates[1].getTime();
                          this._renderChart();
                        }
                    });
  }

  selectDateRange(){
    dateRangeInput.toggle();
  }

  selectApiKey(event) {
    this.selectedApiKey = event.currentTarget.getAttribute("data-api-key-id");
    this.selectedApiKeyTarget.textContent = event.currentTarget.textContent;
    this._renderChart();
  }

  selectInterval(event) {
    this.selectedInterval = event.currentTarget.getAttribute("data-interval");
    this.selectedIntervalTarget.textContent = "Filter Data by " + event.currentTarget.textContent;
    if (this.selectedInterval == "monthly") {
      this.enableDataGrouping = true;
    } else {
      this.enableDataGrouping = false;
    }
    this._renderChart();
  }

  exportData(event) {
    const fileType = event.currentTarget.getAttribute("data-file-type");
    const exportDataUrl = event.currentTarget.getAttribute("data-export-url");

    event.preventDefault();

    const chartData = new FormData();
    chartData.append("format", fileType);
    chartData.append("data", JSON.stringify(this._processChartData));
    chartData.append("interval", this.selectedInterval);

    const options = {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": getCSRFToken()
      },
      responseType: 'blob',
      body: chartData
    }

    fetch(exportDataUrl, options)
      .then(response => response.blob())
      .then((file) => {
        const url = URL.createObjectURL(file);

        const a = document.createElement("a");
        a.href = url;

        const startDate = new Date(this.selectedStartDate);
        const endDate = new Date (this.selectedEndDate);

        a.download = `${startDate.getDate()}-${startDate.toLocaleString('en-US', { month: 'short' })}-${startDate.getFullYear()}to${endDate.getDate()
                      }-${endDate.toLocaleString('en-US', { month: 'short' })}-${endDate.getFullYear()}.${fileType}`;

        a.click();

        // Revoke the object URL to free up memory
        URL.revokeObjectURL(url);
      })
  }

  get _processChartData() {
    const processedData = this.chart.series.reduce((data, series) => {
      series.processedXData.forEach((x, index) => {
        if (!data[x]) {
          data[x] = []
        }

        data[x].push([series.name, series.processedYData[index]])
      })

      return data
    }, {})

    return processedData
  }

  get _historicalChartDataLinks(){
    const baseUrl = new URL(this.urlValue);
    baseUrl.searchParams.set("api_key_id", this.selectedApiKey);
    baseUrl.searchParams.set("start_date", this.selectedStartDate);
    baseUrl.searchParams.set("end_date", this.selectedEndDate);
    return baseUrl.href
  }


  _renderChart(){
    const chartUrl = this._historicalChartDataLinks
    fetch(chartUrl, { credentials: "same-origin" })
      .then(response => response.json())
      .then(data => {
        if (data === null) {
          return;
        }

        Promise.all([import("highcharts/highstock")]).then(res => {

          //this._showSpinner(false);

          const Highcharts = res[0];

          Highcharts.setOptions({ lang: { ...chartTranslations() }, colors: HIGHCHARTS_COLORS });
          this.chart = Highcharts.chart(this.chartTarget.id, {
              chart: {
                type: 'column',
                className: "cg-highcharts"
              },
              title: {
                  text: '',
                  align: 'left'
              },
              xAxis: {
                type: 'datetime',
                title: {
                  enabled: false
                },
              },
              yAxis: {
                  min: 0,
                  title: {
                      text: ''
                  },
              },
              legend: {
                  align: 'center',
                  x: 0,
                  verticalAlign: 'bottom',
                  y: 0,
                  floating: false,
                  backgroundColor:
                      Highcharts.defaultOptions.legend.backgroundColor || 'white',
                  shadow: false,
                  margin: 32
              },
              tooltip: {
                  headerFormat: (this.selectedInterval == "monthly") ? '<b>{point.x: %b %y}</b><br/>' : '<b>{point.x:%b %d}</b><br/>',
                  pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
              },
              plotOptions: {
                  column: {
                      stacking: 'normal',
                      dataGrouping: {
                        enabled: this.enableDataGrouping,
                        forced: true,
                        units: [['month', [1]]]
                      }
                  }
              },
              series: data,
              credits: {
                enabled: false
              },
              loading: {
                labelStyle: {
                  color: '#666'
                },
                style: {
                  backgroundColor: '#eee'
                },
                showDuration: 1000
              }
        })
      })
    })
  }
}
